import React, { Component } from 'react';
import { Container, Row, Col, Spinner } from 'reactstrap';
import axios from '../../utils/request';
import md5 from "md5";

export class SanQiHuYuInviteToExam extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            loading: true,
            code: "",
            tenantId: - 1,
            userId: "",
            personId: "",
            jobId: "",
            timeStamp: -1,
            accepted: "",
            sign: "",
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const personId = urlParams.get("personId");
        const jobId = urlParams.get("jobId");
        const tenantId = urlParams.get("tenantId");
        const userId = urlParams.get("userId");
        const accepted = urlParams.get("accepted");
        const timeStamp = urlParams.get("timeStamp");
        const sign = urlParams.get("sign");

        if (!personId || !jobId || !tenantId || !userId || !accepted || !timeStamp || !sign) {
            this.setState({ message: "参数异常，请联系管理员。", code: "500", loading:false});
            return;
        }
        var str = `${jobId}${personId}${tenantId}${timeStamp}10000`;
        const signNonce = "SanQiHuYuExam2022";
        const signStr = md5(`${jobId}${personId}${tenantId}${timeStamp}10000${signNonce}`);
        console.log(`str:${str}`);
        console.log(`signStr:${signStr}`);
        console.log(`sign:${sign}`);
        if (sign !== signStr) {
            this.setState({ message: "签名错误", code: "500", loading: false});
            return;
        }

        this.setState({ tenantId: tenantId, personId: personId, jobId: jobId, sign: sign, accepted: accepted });
        this.invitationFeedback(tenantId, personId, jobId, accepted, timeStamp)
    };

    invitationFeedback = (tenantId, personId, jobId, accepted, strTimeStamp) => {
        this.setState({ loading: true });

      
       
        const params = {
                "jobId": jobId,
                "tenantId": tenantId,
                "applicantId": personId,
            }

            const bodyString = JSON.stringify(params);
           
            axios.post(
                "/api/SanQiHuYu/Invitation",
                bodyString,
                {
                    params: { tenantId: tenantId, applicantId: personId, jobId: jobId, accept: accepted, message: ""},
                    headers: { "Content-Type": "application/json" }
                }
            ).then(res => {
                const codeValue = res.data.code;
                if (codeValue === "500") {
                    this.setState({ code: codeValue, message: res.data.message, loading: false })
                    return;
                }
                if (this.state.accepted === "1") {
                    window.location.href = "/sanqihuyu_invite_success";
                } else if (this.state.accepted === "2") {
                    const timeStamp = Date.now();
                    const urlQuerys = "tenantId=" + this.state.tenantId + "&applicantId=" + this.state.personId + "&jobId=" + this.state.jobId + "&timestamp=" + timeStamp;
                    const sign = md5(`${urlQuerys}SanQiHuYuExam2022`);
                    window.location.href = "/sanqihuyu_invite_reject?" + urlQuerys + "&signValue=" + sign;
                }
                else {
                    const timeStamp = Date.now();
                    const urlQuerys = "tenantId=" + this.state.tenantId + "&applicantId=" + this.state.personId + "&jobId=" + this.state.jobId + "&timestamp=" + timeStamp;
                    const sign = md5(`${urlQuerys}SanQiHuYuExam2022`);
                    window.location.href = "/sanqihuyu_invite_updatetime?" + urlQuerys + "&signValue=" + sign;
                }
            }).catch(reason => {
                this.setState({ code: "500", message: "发起失败，请稍后再试！", loading: false })
                return;
            }).finally(
            );
       // }
    };

    render() {
        if (!this.state.isLoading) {
            return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.message}</span></div>)
        }
        else {
            return (
                <div>
                    <Container className="themed-container" style={{ backgroundColor: '#FFFFFF', marginTop: '50px', border: "1px solid #ccc", borderRadius: "20px", padding: "30px" }}>
                        <Row>
                            <Col sm="12" md={{ size: 10, offset: 1 }}>                             
                                <div style={{ textAlign: "center", padding: "15px" }}>
                                    <Spinner type="grow" color="primary" />
                                    <Spinner type="grow" color="secondary" />
                                    <Spinner type="grow" color="success" />
                                    <Spinner type="grow" color="danger" />
                                    <Spinner type="grow" color="warning" />
                                    <Spinner type="grow" color="info" />
                                    <Spinner type="grow" color="light" />
                                    <Spinner type="grow" color="dark" />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            );
        }
        
    }
}